module.exports = __webpack_public_path__ + "images/category_lp/smartphone/assessment_achievements/1_61ce9eaba9fd841b05ceb47eebf3141a.jpg";